const aaa = [
	{
		path: "huotiList12",
		component: () => import("@/views/huoti/huoti/huotiList.vue"),
		meta:{title:'活体管理',keepAlive:true},
	},
	{
		path: "huotiDetail",
		component: () => import("@/views/huoti/huoti/huotiDetail.vue"),
		meta:{title:'活体管理'},
	}
]
export default aaa;